"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNodes;

var _selectnodes = _interopRequireDefault(require("./_selectnodes"));

var _dom = _interopRequireDefault(require("../_dom"));

var htmlReg = /</;
var customSelectorReg = /:sandbox|:bound\(([^(]*)\)/; // the function works just like DOM library accepting any kind of arg
// (HTML string, Node, NodeList etc) bu allows to pass custom selector
// eg :bound(KEY) and :sandbox

function getNodes(object, selector) {
  if (typeof selector === 'string' && !htmlReg.test(selector) && customSelectorReg.test(selector)) {
    return (0, _selectnodes["default"])(object, selector);
  }

  return _dom["default"].$(selector);
}
//# sourceMappingURL=_getnodes.js.map